import { component } from 'picoapp'

export default component((node) => {
  // Utility function to show or hide an element based on a condition
  const toggleVisibility = (element, condition) => {
    if (condition) {
      element.style.display = 'block'
    } else {
      element.style.display = 'none'
    }
  }

  // Get the variant badges data from the data attribute
  const variantBadges = node.getAttribute('data-variant-badges')
  if (!variantBadges) return
  const variantBadgesJSON = JSON.parse(variantBadges)

  window.MicroBus.on('variant:change', ({ detail }) => {
    const { variant } = detail
    if (!variantBadgesJSON) return
    // Find the corresponding variant data
    const currentVariantBadge = variantBadgesJSON.find((v) => v.id === variant.id)

    // Get the badge text
    const badgeText = currentVariantBadge ? currentVariantBadge.badge_text : ''
    // Get the product badge text element
    const badgeTextElement = node.querySelector('#productBadge-text')

    // Update the badge text element
    toggleVisibility(badgeTextElement, badgeText)
    if (badgeText) {
      badgeTextElement.innerHTML = badgeText
    }

    // Get the badge image
    const badgeImage = currentVariantBadge ? currentVariantBadge.badge_image : ''
    // Get the product badge image element
    const badgeImageElement = node.querySelector('#productBadge-image')

    // Update the badge image element
    toggleVisibility(badgeImageElement, badgeImage)
    if (badgeImage) {
      let imgElement = badgeImageElement.querySelector('img')
      if (!imgElement) {
        imgElement = document.createElement('img')
        imgElement.setAttribute('srcset', badgeImage)
        imgElement.setAttribute('class', 'tw-max-w-[60px] tw-h-auto')
        badgeImageElement.appendChild(imgElement)
      } else {
        imgElement.setAttribute('srcset', badgeImage)
      }
    }

    // Hide the default savings tag if any badge text or image is not empty
    const savingsTagElement = node.querySelector('#productBadge-savings-tag')
    toggleVisibility(savingsTagElement, !(badgeText || badgeImage) && variant.compare_at_price > variant.price)
  })
})
